import TextField from '@material-ui/core/TextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import ExpandableListElementStyle from '../../styles/ExpandableListElementStyle'
import ListItemMenu from './ListItemMenu'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core'

class ExpandableListElement extends React.Component {
  state = {
    isExpanded: true,
    isActive: false,
    isMouseEnter: false,
  }

  handleClick = (e, nazwa) => {
    if (nazwa) {
      if (!this.props.expandationDisabled)
        this.setState({ isExpanded: !this.state.isExpanded, isActive: false })
      else this.setState({ isActive: false })
    } else {
      e.stopPropagation()
    }
  }

  handleClickTextField = (e) => {
    e.stopPropagation()
  }

  handleToggleActive = (value) => {
    this.setState({ isActive: value })
  }

  handleToggleIsMouseEnter = (value) => {
    this.setState({ isMouseEnter: value })
  }

  render() {
    const {
      children,
      onDeleteDetail,
      onSetSectionDataArray,
      index,
      isActive,
      hasError,
      nazwaPozycji,
      sectionIndex,
      placeholder,
      expandationDisabled,
      multiRow,
    } = this.props

    const { isExpanded, isMouseEnter } = this.state
    const options = [
      { title: 'USUŃ', action: () => onDeleteDetail(index, sectionIndex) },
    ]
    return (
      <ExpandableListElementStyle isExpanded={isExpanded} multiRow={multiRow}>
        <Accordion
          expanded={isExpanded}
          onClick={(e) => this.handleClick(e, nazwaPozycji)}
          className={
            this.state.isActive || isActive
              ? 'active expansionPanel'
              : 'expansionPanel'
          }
          onMouseEnter={() => this.handleToggleIsMouseEnter(true)}
          onMouseLeave={() => this.handleToggleIsMouseEnter(false)}
        >
          <AccordionSummary
            classes={{
              content: 'expansion-panel-summary-content',
              expanded: 'expansion-panel-summary-expanded',
              expandIcon: 'expansion-panel-summary-expandIcon',
            }}
            expandIcon={
              !expandationDisabled &&
              nazwaPozycji && <ExpandMoreIcon color="primary" />
            }
          >
            <div className={isExpanded ? '' : 'title'}>
              {isExpanded ? (
                <TextField
                  error={hasError('Nazwa', nazwaPozycji)}
                  className="inputTitle"
                  name="Nazwa"
                  onClick={this.handleClickTextField}
                  placeholder={placeholder}
                  multiline
                  rowsMax="4"
                  title={nazwaPozycji}
                  value={nazwaPozycji}
                  onChange={(e) =>
                    onSetSectionDataArray(e, index, sectionIndex)
                  }
                  margin="normal"
                  onFocus={() => this.handleToggleActive(true)}
                  onBlur={() => this.handleToggleActive(false)}
                  helperText={this.props.helperText}
                />
              ) : (
                <span className="high-emphasis-body-1">{nazwaPozycji}</span>
              )}
              {((nazwaPozycji && isExpanded) || isMouseEnter) && (
                <ListItemMenu options={options} />
              )}
            </div>
          </AccordionSummary>
          <AccordionDetails
            className="details"
            onClick={this.handleClickTextField}
          >
            {children}
          </AccordionDetails>
        </Accordion>
      </ExpandableListElementStyle>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onDeleteDetail: (index, sIndex) => {
      dispatch(actions.deleteDetail(index, sIndex))
    },
    onSetSectionDataArray: (e, index, sectionIndex) => {
      let { value, name } = e.target
      dispatch(actions.setSectionDataArray(value, index, sectionIndex, name))
    },
  }
}

export default connect(null, mapDispatchToProps)(ExpandableListElement)
